/**
 * Responsibility: read how far through each set a collection is.
 *
 * Separate from the collection query because the answer depends on the
 * population universe as well as the holdings, and that universe is refetched
 * every few days rather than on every page view.
 */
import { useQuery } from '@tanstack/react-query';

import { hubApi } from '../client';

export const setKeys = {
  all: () => ['collection', 'sets'] as const,
  detail: (label: string) => ['collection', 'sets', label] as const,
};

export function useCollectionSets() {
  return useQuery({
    queryKey: setKeys.all(),
    queryFn: () => hubApi.collectionSets(),
  });
}

/**
 * Every card in one set, marked owned or missing.
 *
 * Only fetched once a set is actually being looked at: the response carries a
 * row per card, which for a modern set is a few hundred.
 */
export function useSetDetail(label: string | null) {
  return useQuery({
    queryKey: setKeys.detail(label ?? ''),
    queryFn: () => hubApi.setDetail(label as string),
    enabled: label !== null,
  });
}
